import React from "react";
import {createRoot} from "react-dom/client";

import TmsCandidateWidget from "components/TmsCandidateWidget";

export function init(domElement) {
    /**
     * @description override default dom element for joblist
     * @type {NodeListOf<Element>}
     */

    const tagList = domElement || document.querySelectorAll("tms-candidate-widget");
    // const joblist =

    for (let i = 0; i < tagList.length; i++) {
        const root = createRoot(tagList[i]); // createRoot(container!) if you use TypeScript
        root.render(
            <React.StrictMode>
                <TmsCandidateWidget attribute={tagList[i].attributes} />
            </React.StrictMode>
        )
        ;

    }
    // const app = render(<TmsJoblist setFilter />, tag);
}
